import React, { useState } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard, faCheck } from '@fortawesome/pro-solid-svg-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { connect } from 'react-redux';

export function DealInboxEmailAddress({ inboxEmailAddress }) {
  const [copied, setCopied] = useState();

  if (!inboxEmailAddress) {
    return null;
  }

  function copy() {
    navigator.clipboard.writeText(inboxEmailAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  const overlay = (
    <Tooltip id="copy-email-address">
      Copy email address for this deal
    </Tooltip>
  );

  return (
    <div className="text-muted">
      <OverlayTrigger overlay={overlay} placement="bottom">
        <FontAwesomeIcon
          className={classNames('clipboard-icon clickable ml-2', { 'text-success': copied })}
          icon={copied ? faCheck : faClipboard}
          onClick={copy}
        />
      </OverlayTrigger>
    </div>
  );
}

DealInboxEmailAddress.propTypes = {
  inboxEmailAddress: PropTypes.string,
};

const mapStateToProps = state => ({
  inboxEmailAddress: state.deal.inboxEmailAddress,
});

export default connect(mapStateToProps)(DealInboxEmailAddress);
